var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgBradesco = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#CC092F"
  }), React.createElement("path", {
    d: "M15.4097 9.55953C14.1273 9.55953 12.7304 9.68152 11.3498 9.91997C12.7467 8.09561 14.9677 6.91449 17.4396 6.91449C19.2677 6.91449 21.0902 7.61318 22.318 8.65567C22.5418 8.84421 22.7109 8.86084 22.8801 8.68894C23.0492 8.51704 23.0329 8.34514 22.8473 8.12334C21.243 6.22689 18.8857 4.95151 16.1081 5.00141C12.4739 5.06796 9.38533 7.40801 8.20666 10.6464C7.13166 10.9902 6.14397 11.395 5.27088 11.894C5.03078 12.0327 4.94893 12.199 5.03078 12.4042C5.11809 12.5927 5.28725 12.6593 5.52735 12.5927C6.28039 12.3709 7.04435 12.1824 7.84651 12.0105C7.7592 12.4375 7.71008 12.8811 7.71008 13.3413C7.63915 16.3246 9.21071 19.1582 11.6335 20.7108C11.8736 20.8661 12.0755 20.8661 12.212 20.6776C12.3484 20.489 12.332 20.3171 12.1247 20.1341C10.5913 18.7368 9.73457 16.6518 9.73457 14.589C9.73457 13.5465 9.94193 12.5428 10.3294 11.639C11.1315 11.5724 11.9992 11.517 12.9596 11.517C19.1694 11.517 24.408 13.5964 24.408 16.3302C24.408 17.7109 22.6836 19.0916 20.6373 20.0177C20.1407 20.2395 20.0916 20.3948 20.1571 20.6166C20.2281 20.8217 20.4463 20.8883 20.7028 20.8051C24.2879 19.6129 27 17.6499 27 15.2766C27.0109 12.0493 21.8924 9.55953 15.4097 9.55953Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M18.2 25.8091V19.352C18.2 19.1033 17.9981 19.0152 17.8313 19.1292L16.44 20.0724V26.12H17.9323C18.0815 26.12 18.2 25.9801 18.2 25.8091Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M13.8 21.1063V25.903C13.8 26.0254 13.9072 26.12 14.046 26.12H15.56V19.96L14.046 20.7279C13.8946 20.8058 13.8 20.9282 13.8 21.1063Z",
    fill: "white"
  }));
};
export default SvgBradesco;